// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ff-a";
export var fulfillmentFormRail = "_ff-9";
export var headerTitleRow = "_ff-c";
export var orderDetailsWrapper = "_ff-7";
export var orderLinkTrigger = "_ff-2";
export var paymentInformationGrid = "_ff-h";
export var paymentSummaryColumn = "_ff-i";
export var shipmentContainer = "_ff-b";
export var shipmentDetailsMainPane = "_ff-8";
export var shipmentNavigationCard = "_ff-5";
export var shipmentNavigationRail = "_ff-3";
export var shipmentNavigationRailHeader = "_ff-4";
export var shipmentSummaryFact = "_ff-e";
export var shipmentSummaryGrid = "_ff-d";
export var shipmentSummaryMetadataRow = "_ff-f";
export var shipmentSummaryTags = "_ff-g";
export var shipmentWorkspace = "_ff-0";
export var shipmentWorkspaceContent = "_ff-6";
export var shipmentWorkspaceHeader = "_ff-1";